<template>
	<div class="empty-container">
		<nut-icon
			class="empty-icon"
			class-prefix="icon"
			font-class-name="iconfont"
			name="empty"
			size="48"
		>
		</nut-icon>
		<span class="empty-text">{{ text || '暂无数据～' }}</span>
	</div>
</template>

<script>
export default {
	name: 'Empty',
	props: {
		text: String,
	},
};
</script>

<style lang="scss" scoped>
.empty {
	&-container {
		@include flex-center;
		flex-direction: column;
		justify-content: center;
		height: 300px;
		background: #fff;
	}

	&-icon {
		color: $primary-color;
		margin-bottom: 12px;
	}

	&-text {
		font-size: $small-font-size;
		color: $grey-font-color;
	}
}
</style>
